import { Icon } from '~src/components/Icon';

import { DualDropdownOption } from './types';

export const DEFAULT_HEATING_OPTIONS: DualDropdownOption[] = [
  { value: 'radiator', label: 'Radiatorer', Icon: Icon.Radiator },
  { value: 'floor', label: 'Gulvvarme', Icon: Icon.FloorHeating },
  {
    value: 'radiatorAndFloor',
    label: 'Gulvvarme og radiatorer',
    Icon: Icon.Radiator,
    SecondaryIcon: Icon.FloorHeating,
  },
];
